<template>
  <div id="layout">
    <div id="header">
      <panel-logout />
      <club-navbar />
    </div>
    <div class="left">
      <sub-navigation />
      <slot></slot>
    </div>
    <div class="right">
      <panel-locale />
      <panel-balance />
      <notification-invoice-create />
      <notification-invoice-deposit />
      <notification-invoice-lock />
      <notification-invoice-remove />
      <notification-invoice-unlock />
      <notification-invoice-withdraw />
      <notification-error />
      <notification-invoice-lock-asterisk />
    </div>
    <div class="clear"></div>
    <panel-invoice-remove />
    <panel-loading />
  </div>
</template>

<script>
  import ClubNavbar from './navigation/ClubNavbar';
  import SubNavigation from './navigation/ClubNavbarSub';
  import NotificationError from './notifications/NotificationError';
  import NotificationInvoiceCreate from './notifications/NotificationInvoiceCreate';
  import NotificationInvoiceDeposit from './notifications/NotificationInvoiceDeposit';
  import NotificationInvoiceLock from './notifications/NotificationInvoiceLock';
  import NotificationInvoiceLockAsterisk from './notifications/NotificationInvoiceLockAsterisk';
  import NotificationInvoiceRemove from './notifications/NotificationInvoiceRemove';
  import NotificationInvoiceUnlock from './notifications/NotificationInvoiceUnlock';
  import NotificationInvoiceWithdraw  from './notifications/NotificationInvoiceWithdraw';
  import PanelInvoiceRemove from './panels/PanelInvoiceRemove/PanelInvoiceRemove';
  import PanelBalance from './panels/PanelBalance';
  import PanelLoading from './panels/PanelLoading';
  import PanelLocale from './panels/PanelLocale';
  import PanelLogout from './panels/PanelLogout';

  export default {
    name: 'ClubLayout',
    components: {
      ClubNavbar,
      SubNavigation,
      NotificationError,
      NotificationInvoiceCreate,
      NotificationInvoiceDeposit,
      NotificationInvoiceLock,
      NotificationInvoiceLockAsterisk,
      NotificationInvoiceRemove,
      NotificationInvoiceUnlock,
      NotificationInvoiceWithdraw,
      PanelInvoiceRemove,
      PanelBalance,
      PanelLoading,
      PanelLocale,
      PanelLogout,
    },
}
</script>

<style scoped>
  #layout {
    width: 1200px;
    min-width: 600px;
    text-align: left;
    margin: 0 auto;
    padding: 0 35px;
    border: 0;
    font-size: 100%;
    font-style: normal;
    vertical-align: baseline;
    outline: 0;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  #header {
    color: #000;
    display: block;
    outline: 0;
    font-style: normal;
    font-size: 100%;
    padding-top: 10px;
    padding-bottom: 24px;
    position: relative;
    text-align: center;
  }

  .left {
    margin-right: 10px;
    width: 860px;
    float: left;
    padding: 0;
    border: 0;
    font-size: 100%;
    font-style: normal;
    outline: 0;
    display: block;
    text-align: left;
    font-family: Verdana, sans-serif;
    color: #000;
  }

  .right {
    position: relative;
    float: left;
    min-width: 320px;
    max-width: 320px;
    margin-top: 5px;
    margin-left: 10px;
  }

  .clear {
    clear: both;
  }
</style>
